import { createContext, useState, useContext, useEffect, ReactElement } from 'react';
import { IBusinessUnit, getBusinessUnitsByUserId } from 'wisestep-api';

interface BUContextProviderProps {
  children: ReactElement;
}
export const BusinessUnitContext = createContext<IBusinessUnit[] | null>(null);

export default function BusinessUnitContextProvider(props: BUContextProviderProps) {
  const [buList, setBUList] = useState<IBusinessUnit[] | null>(null);
  const [isLoaded, setIsLoded] = useState(false);

  useEffect(() => {
    (async function () {
      if (!isLoaded) {
        try {
          const businessUnitsList = await getBusinessUnitsByUserId();

          setBUList(
            businessUnitsList.data.map((bu: IBusinessUnit) => ({
              id: bu.id,
              name: bu.name,
              active: bu.active,
              workspaceId: bu.workspaceId,
              createdBy: bu.createdBy,
              createdOn: bu.createdOn,
              modifiedBy: bu.modifiedBy,
              modifiedOn: bu.modifiedOn,
              description: bu.description,
            }))
          );
          setIsLoded(true);
        } catch {
          setBUList([]);
          setIsLoded(true);
        }
      }
    })();
  }, [isLoaded]);

  return (
    <BusinessUnitContext.Provider value={buList}>{props.children}</BusinessUnitContext.Provider>
  );
}

export function useBusinessUnitContext() {
  const context = useContext(BusinessUnitContext);
  if (!context) {
    throw new Error('useAppState must be used within the BusinessUnitContextProvider');
  }
  return context;
}
